import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal, ModalBody, ModalFooter } from "reactstrap";
function ModalConfirmation({ isOpen, title, message, isToggle, handleOption }) {
  if (title == "Are you sure you want to cancel this pick up process?") {
    return (
      <Modal
        isOpen={isOpen}
        toggle={isToggle}
        className="confirmation-modal-wrapper"
      >
        <ModalBody className="confirmation-modal-body-wrapper">
          <p style={{textAlign: "center"}}>{title}</p>
        </ModalBody>
        <ModalFooter className="confirmation-modal-footer-wrapper">
          <div
            onClick={() => {
              isToggle();
            }}
            className="confirmation-button"
          >
            <p>No</p>
          </div>
          <div
            onClick={() => {
              isToggle();
              handleOption();
            }}
            className="confirmation-button cancel-button"
          >
            <p style={{color: "red"}}>Yes</p>
          </div>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={isToggle}
      className="confirmation-modal-wrapper"
    >
      <ModalBody className="confirmation-modal-body-wrapper">
        {title === "Delete Address" ? (
          <p>Are you sure you want to delete this address?</p>
        ) : (
          <p>Are you sure you want to set this address as default?</p>
        )}
      </ModalBody>
      <ModalFooter className="confirmation-modal-footer-wrapper">
        <div
          onClick={() => {
            isToggle();
            handleOption(false);
          }}
        >
          <p>Cancel</p>
        </div>

        {title === "Delete Address" ? (
          <div
            onClick={() => {
              isToggle();
              handleOption();
            }}
          >
            <p>Delete</p>
          </div>
        ) : (
          <div
            onClick={() => {
              isToggle();
              handleOption();
            }}
            style={{ backgroundColor: "#159953" }}
          >
            <p>Set as deffault</p>
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default ModalConfirmation;
